import { mutatorAction } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";
import getStore from "../store";
import { isDismissedToday, saveNeedsReplyDismissState } from "../utils/localStorageHelper";

const resetWasDismissedMutator: (mailboxInfo: MailboxInfo, force?: boolean) => void = mutatorAction("resetReplyNudgeWasDismissed", (mailboxInfo: MailboxInfo, force?: boolean): void => {
    // Don't re-show the nudge if the user already dismissed it today,
    // unless forced (e.g., a new NR email arrived)
    if (!force && isDismissedToday(mailboxInfo)) {
        return;
    }
    if (force) {
        saveNeedsReplyDismissState(mailboxInfo, null);
    }
    getStore().wasDismissed = false;
});

export default resetWasDismissedMutator;
